export enum VisualEditorMode {
  LazyLoad = 'lazyLoad',
  InjectScript = 'injectScript',
}
